import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { BeneficiaryDependentDto } from '../../../../../modules/beneficiaries/dtos/beneficiary-dependent';
import { BeneficiaryWalletDto } from '../../../../../modules/beneficiaries/dtos/beneficiary-wallet';
import { WalletType } from '../../../../../shared/enums/wallet-type.enum';
import { EnumUtils } from '../../../../../utils/enum.utils';

@Component({
	selector: 'app-dependent-info',
	styleUrls: ['./dependent-info.component.scss'],
	templateUrl: './dependent-info.component.html',
})
export class DependentInfoComponent implements OnInit {
	@Input() beneficiaryType: string = '';
	@Output() deleteDependent: EventEmitter<BeneficiaryDependentDto> =
		new EventEmitter();
	@Input() dependent?: BeneficiaryDependentDto | null;

	@Output() editBenefits: EventEmitter<BeneficiaryDependentDto> =
		new EventEmitter();
	@Output() editDependent: EventEmitter<string> = new EventEmitter();
	@Input() organizationId: string = '';

	dentalBenefitData: BeneficiaryWalletDto | null = null;
	healthBenefitData: BeneficiaryWalletDto | null = null;
	isDisabledButton: boolean = false;

	getDependentType(): string {
		const dependentType = this.dependent?.typeKinship;

		if (!dependentType) {
			return '';
		}

		if (!isNaN(Number(dependentType))) {
			return (
				EnumUtils.getKinship(
					EnumUtils.getKinshipFromNumberValue(dependentType),
				) ?? ''
			);
		} else {
			return EnumUtils.getKinship(dependentType.toString()) ?? '';
		}
	}

	getDependentUrl(): string {
		return `/organizacoes/${this.organizationId}/beneficiarios/${
			this.dependent?.id
		}`;
	}

	ngOnInit(): void {
		this.dentalBenefitData = this.getBenefitData(
			(benefit) => benefit.is_dental,
		);
		this.healthBenefitData = this.getBenefitData(
			(benefit) => benefit.is_health,
		);

		this.isDisabledButton =
			this.beneficiaryType === 'inativo' ||
			this.beneficiaryType === 'aposentado';
	}

	onDeleteDependent(): void {
		if (this.dependent) {
			this.deleteDependent.emit(this.dependent);
		}
	}

	onEditBenefits(): void {
		if (this.dependent) {
			this.editBenefits.emit(this.dependent);
		}
	}

	onEditDependent(): void {
		if (this.dependent) {
			this.editDependent.emit(this.dependent.id);
		}
	}

	private getBenefitData(
		matchesBenefitType: (benefit: BeneficiaryWalletDto) => boolean,
	): BeneficiaryWalletDto | null {
		const benefits = this.dependent?.benefits.filter(matchesBenefitType) ?? [];

		return (
			benefits.find((benefit) => benefit.type === WalletType.DEFAULT) ||
			benefits.find((benefit) => benefit.type === WalletType.CONJUGATED) ||
			benefits.find(
				(benefit) => !benefit.not_aplicable && !!benefit.wallet_number,
			) ||
			benefits.find((benefit) => !benefit.not_aplicable) ||
			benefits[0] ||
			null
		);
	}
}
